import { DailyUserConstants } from "../constants/dailyuser.constants";

const DailyUserReducer = (state, action) => {
  switch (action.type) {
    case DailyUserConstants.FETCH_DAILY_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case DailyUserConstants.FETCH_DAILY_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dailyUsers: action.payload.data,
        paging: action.payload.paging,
      };
    case DailyUserConstants.FETCH_DAILY_USER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };
    case DailyUserConstants.FETCH_DASHBOARD_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case DailyUserConstants.FETCH_DASHBOARD_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dashboardUsers: action.payload,
      };
    case DailyUserConstants.FETCH_DASHBOARD_USER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case DailyUserConstants.DAILY_USER_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case DailyUserConstants.DAILY_USER_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dailyUserSearchResults: action.payload,
      };
    case DailyUserConstants.DAILY_USER_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case DailyUserConstants.DAILY_USER_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case DailyUserConstants.DAILY_USER_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dailyUserAutoSearchResults: action.payload,
      };
    case DailyUserConstants.DAILY_USER_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case DailyUserConstants.ADD_DAILY_USER_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case DailyUserConstants.ADD_DAILY_USER_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case DailyUserConstants.ADD_DAILY_USER_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
        errorMessage: action.payload.message,
      };

    case DailyUserConstants.GET_DAILY_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case DailyUserConstants.GET_DAILY_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dailyUser: action.payload,
      };
    case DailyUserConstants.GET_DAILY_USER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case DailyUserConstants.UPDATE_DAILY_USER_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case DailyUserConstants.UPDATE_DAILY_USER_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        dailyUser: action.payload,
      };
    case DailyUserConstants.UPDATE_DAILY_USER_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
      };
    case DailyUserConstants.DOWNLOAD_DAILY_USER_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case DailyUserConstants.DOWNLOAD_DAILY_USER_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case DailyUserConstants.DOWNLOAD_DAILY_USER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case DailyUserConstants.UPLOAD_DAILY_USER_REQUEST:
      return {
        ...state,
        isUpload: true,
        uploadError: false,
      };
    case DailyUserConstants.UPLOAD_DAILY_USER_SUCCESS:
      return {
        ...state,
        uploadSuccess: true,
        uploadError: false,
        isUpload: false,
      };
    case DailyUserConstants.UPLOAD_DAILY_USER_FAILURE:
      return {
        ...state,
        uploadError: true,
        isUpload: false,
      };

    default:
      return state;
  }
};

export default DailyUserReducer;
